import { render } from "./TransferRefundConfirmationDialog.vue?vue&type=template&id=4f1852c3"
import script from "./TransferRefundConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./TransferRefundConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__